import { cn } from "@/lib/utils";

const DEFAULT_LOGO_SRC = "/login-assets/invector-logo.svg";

/**
 * invector 워드마크. 기본 크기는 Figma mainHeader 의 75×14.
 * src 는 오프라인 HTML(다운로드) 처럼 경로 접근이 안 될 때 data URI 로 바꿔 끼운다.
 */
export const InvectorLogo = ({
  src = DEFAULT_LOGO_SRC,
  className,
}: {
  src?: string;
  className?: string;
}) => (
  <img
    src={src}
    alt="invector"
    className={cn("h-[14px] w-[75px]", className)}
  />
);
